import { Component } from '@verndale/core';
import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

class Module extends Component {
  setupDefaults() {
    this.dom = {
      body: document.querySelector('body'),
      decorator: this.el.querySelector('.solutions-grid__decorator img'),
      jumpLinks: [...this.el.querySelectorAll('a[href^="#"]')]
    };

    ScrollTrigger.matchMedia({
      '(max-width: 1024px)': () => {
        this.initShapeAnimationMobile();
      },
      '(min-width: 1025px)': () => {
        this.initShapeAnimationDesktop();
      }
    });
  }

  addListeners() {
    this.dom.jumpLinks.forEach(link => {
      link.addEventListener('click', this.handleJumpLinkClick.bind(this))
    })
  }

  handleJumpLinkClick(e) {
    e.preventDefault();
    console.log(e.currentTarget.getAttribute('href'))

    const targetId = e.currentTarget.getAttribute('href');
    this.jumpToAnchor(targetId, true);
  }

  jumpToAnchor(targetId, push) {
    const target = document.getElementById(targetId.replace('#', ''));

    if (target) {
      gsap.to(window, { duration: 1, scrollTo: target.offsetTop - 180 });

      if (push) {
        history.pushState(null, null, targetId);
      }
    }
  }

  initShapeAnimationDesktop() {
    gsap.from(this.dom.decorator, {
      scrollTrigger: {
        trigger: this.el,
        end: 'center 25%',
        scrub: true
      },
      opacity: 0,
      scale: 0.65,
      rotation: -20
    });
  }

  initShapeAnimationMobile() {
    gsap.set(this.dom.decorator, { top: 0, opacity: 1, rotate: 0, scale: 1 });
    gsap.to(this.dom.decorator, {
      top: 500,
      scrollTrigger: {
        trigger: this.el,
        start: 'top 25%',
        end: 'bottom 75%',
        scrub: true
      }
    });
  }
}

export default Module;
